export const XXL_BREAKPOINT_PX = 1920;
export const LG_MIN_WIDTH_COLS = 4;
export const GRID_COLS = 12;
